import React, { FC } from 'react';
import { NavLink } from 'react-router-dom';
import useRootSelector from 'common/hooks/useRootSelector';
import { Avatar, Box, CircularProgress, Grid, makeStyles, Typography } from '@material-ui/core';
import { ReactComponent as DefaultIcon } from 'img/icons/default-icon.svg';
import { HeaderId } from 'common/enums/html.enums';
import {
  selectMemberProfile,
  selectMemberProfileLoading,
} from 'memberPortalModules/MemberProfile/state/profile/selectors';
import { Routes } from 'constants/route.constants';
import { renderTimezoneOption } from 'modules/corporate-settings/utils/timezoneUtils';

const useStyles = makeStyles(theme => ({
  clubLogo: {
    width: 36,
    height: 36,
  },

  organizationOption: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(0.5),
    marginLeft: theme.spacing(3),
  },
  organizationTitle: {
    textTransform: 'none',
    fontWeight: 600,
  },
  dropDownIcon: {
    marginLeft: theme.spacing(1),
  },
  link: { display: 'flex' },
}));

const MemberPortalHeaderClubLogo: FC = () => {
  const classes = useStyles();
  const selectedMember = useRootSelector(selectMemberProfile);
  const selectedMemberLoading = useRootSelector(selectMemberProfileLoading);

  const homeClub = selectedMember?.get('homeClub');

  if (selectedMemberLoading) {
    return <CircularProgress color="secondary" />;
  }

  return (
    <Grid item>
      {homeClub ? (
        <NavLink to={Routes.HOME}>
          <Box className={classes.link}>
            <Avatar
              id={HeaderId.HeaderBtnClubLogo}
              className={classes.clubLogo}
              variant={homeClub.get('imageUrl') ? 'rounded' : 'circular'}
              alt={homeClub.get('title')}
              src={homeClub.get('imageUrl')}
            >
              <DefaultIcon />
            </Avatar>
            <Typography className={classes.organizationOption}>
              <Typography component="span" color="secondary" className={classes.organizationTitle}>
                {homeClub.get('title')}
              </Typography>

              <Typography component="span" variant="body2" color="secondary">
                {renderTimezoneOption(homeClub.get('timezone'))}
              </Typography>
            </Typography>
          </Box>
        </NavLink>
      ) : null}
    </Grid>
  );
};

export default MemberPortalHeaderClubLogo;
